
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/start/form",
      function () {
        return require("private-next-pages/start/form/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/start/form"])
      });
    }
  